import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { ObjectType } from '../../entities/forms/object-type';
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})

export class ObjectTypesService {
  // Define API
  apiURL = environment.apiUrl;

  constructor(private http: HttpClient) { }
  /*========================================
  CRUD Methods for consuming RESTful API
  =========================================*/
  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  // HttpClient API get() method => Fetch forms list
  getObjectTypes(): Observable<ObjectType> {
    return this.http.get<ObjectType>(this.apiURL + '/gettipoobjeto')
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  // HttpClient API get() method => Fetch form
  getObjectType(id): Observable<ObjectType> {
    return this.http.get<ObjectType>(this.apiURL + '/tipo_objeto/' + id)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // HttpClient API post() method => Create form
  createObjectType(objectType): Observable<ObjectType> {
    return this.http.post<ObjectType>(this.apiURL + '/tipo_objeto/0', JSON.stringify(objectType), this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  // HttpClient API put() method => Update form
  updateObjectType(id, objectType): Observable<ObjectType> {
    return this.http.put<ObjectType>(this.apiURL + '/tipo_objeto/' + id, JSON.stringify(objectType), this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  // HttpClient API delete() method => Delete form
  deleteObjectType(id) {
    return this.http.delete<ObjectType>(this.apiURL + '/tipo_objeto/' + id, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // Error handling
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}

